const appendCIDToUrl = link => {
  let url = new URL(link.href);
  url.searchParams.append('cid', store.get('__cid'));
  link.setAttribute('href', url);
};

export const appendCidToMenuLinks = () => {
  const burgerMenuLinks = document.querySelectorAll('a[data-e2e="burger-menu-sign-in"]');
  const footerLinks = document.querySelectorAll('a[data-e2e="footer-sign-in"]');

  burgerMenuLinks.forEach(e => appendCIDToUrl(e));
  footerLinks.forEach(e => appendCIDToUrl(e));
};
